import { render, staticRenderFns } from "./UsersPendingActivationList.vue?vue&type=template&id=3289ef5e"
import script from "./UsersPendingActivationList.vue?vue&type=script&lang=js"
export * from "./UsersPendingActivationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports